export const isUserOnMobile = () => {
    const ua = navigator.userAgent;
    if (/Mobi|Android|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
        return true;
    }
    return false;
};
